const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    token: state => state.user.token,
    token_type: state => state.user.token_type,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    permissions:state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    errorLogs: state => state.errorLog.logs,
    userinfo: state => state.user.userinfo,
    message: state => state.message.msg,
    message_total: state => state.message.msg_total,
    message_unread: state => state.message.msg_unread,
    history_selectFrom: state => state.tagsView.selectFrom

};
export default getters
